import { useTranslation } from "react-i18next";
import { Props, SortByOptionValue, SortByQuickFilter, SORT_BY_QF_NAMES } from "./interfaces";
import { ListSortDirection } from "../../../models/api/sort";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const SortByQuickfilter = <Q extends SortByQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  isExpenseReportOrReceipt = "report",
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.sort_by";

  const options: QuickFilterOption<SortByOptionValue>[] = [
    ...(isExpenseReportOrReceipt === "report"
      ? [
          {
            name: `${t(`${tRP}.date`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "date", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.date`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "date", direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.le`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "legalEntity", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.le`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "legalEntity", direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.employee`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "employee", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.employee`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "employee", direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.status`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "status", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.status`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "status", direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.modified_at`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "modifiedAt", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.modified_at`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "modifiedAt", direction: ListSortDirection.Ascending }] },
          },
        ]
      : [
          {
            name: `${t(`${tRP}.date`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.date, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.date`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.date, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.amount`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.amount, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.amount`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.amount, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.country`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.country, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.country`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.country, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.description`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.description, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.description`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.description, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.type`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.type, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.type`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.type, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.audit_accepted`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.auditAccepted, direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.audit_accepted`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: SORT_BY_QF_NAMES.auditAccepted, direction: ListSortDirection.Ascending }] },
          },
          {
            name: `${t(`${tRP}.modified_at`)} ${t(`${tRP}.des`)}`,
            value: { sortBy: [{ name: "modifiedAt", direction: ListSortDirection.Descending }] },
          },
          {
            name: `${t(`${tRP}.modified_at`)} ${t(`${tRP}.asc`)}`,
            value: { sortBy: [{ name: "modifiedAt", direction: ListSortDirection.Ascending }] },
          },
        ]),
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="sortByOptions"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
